

import { Instance, types } from 'mobx-state-tree';

export const BaseTranslatableModel = types.model('BaseTranslatableModel', {
  value: types.optional(types.union(types.string, types.undefined, types.null), ''),
  secondaryValue: types.optional(types.union(types.string, types.undefined, types.null), ''),
  thirdValue: types.optional(types.union(types.string, types.undefined, types.null), ''),
});


export type IBaseTranslatableModel = Instance<typeof BaseTranslatableModel>;